function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { circle } from '@sie/web-common-utils';
import classNames from '../../utils/classNames';
/**
 * The DelayFeedback component provides feedback to the user that something is going to happen
 * after some delay
 *
 * ## Related Components
 * - [Trigger](../README.md)
 *
 * ## Props
 */

var DelayFeedback = /*#__PURE__*/function (_PureComponent) {
  _inherits(DelayFeedback, _PureComponent);

  var _super = _createSuper(DelayFeedback);

  function DelayFeedback() {
    _classCallCheck(this, DelayFeedback);

    return _super.apply(this, arguments);
  }

  _createClass(DelayFeedback, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          isActive = _this$props.isActive,
          isInitiated = _this$props.isInitiated,
          className = _this$props.className,
          hoverDelay = _this$props.hoverDelay,
          path = _this$props.path;
      var strokeOpacity = isActive || !isInitiated ? 0 : 1;
      return /*#__PURE__*/React.createElement("svg", {
        "data-qa": qa,
        className: classNames(className, 'psw-border-color-accent-1'),
        width: "100%",
        height: "100%",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none"
      }, path === 'circle' ? /*#__PURE__*/React.createElement("circle", {
        transform: "rotate(90 50 50)",
        "data-qa": "".concat(qa, "#feedback"),
        style: {
          fill: 'transparent',
          strokeOpacity: strokeOpacity,
          transition: "stroke-dashoffset ".concat(isInitiated ? hoverDelay : 0, "ms ease")
        },
        cx: 50,
        cy: 50,
        strokeWidth: 4,
        r: 48,
        strokeDasharray: circle.perimeter(48),
        strokeDashoffset: circle.perimeter(48) * (1 - (isInitiated ? 1 : 0))
      }) : /*#__PURE__*/React.createElement("line", {
        x1: "0",
        x2: "100%",
        y1: "100%",
        y2: "100%",
        style: {
          fill: 'transparent',
          strokeOpacity: strokeOpacity,
          transition: "stroke-dashoffset ".concat(isInitiated ? hoverDelay : 0, "ms ease")
        },
        strokeWidth: "4",
        strokeDasharray: "100%",
        strokeDashoffset: isInitiated ? 0 : '100%'
      }));
    }
  }]);

  return DelayFeedback;
}(PureComponent);

DelayFeedback.defaultProps = {
  qa: '',
  className: '',
  isActive: false,
  isInitiated: false,
  hoverDelay: 350,
  path: 'circle'
};
DelayFeedback.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Whether the delay is complete
   */
  isActive: PropTypes.bool,

  /**
   * Whether the delay is initiated
   */
  isInitiated: PropTypes.bool,

  /**
   * The amount of hover delay in milliseconds
   */
  hoverDelay: PropTypes.number,
  path: PropTypes.oneOf(['line', 'circle'])
};
export default DelayFeedback;